import React from 'react';
import { Typography, Box } from '@mui/material';

const SearchLoadingText = () => {
  return (
    <Box>
      <Typography
        variant="body1"
        component="div"
        sx={{
          fontWeight: 'bold',
          color: 'transparent',
          backgroundImage: 'linear-gradient(90deg, #7dd3fc 0%, #2563eb 33%, #ffffff 66%, #7dd3fc 100%)',
          backgroundSize: '300% auto',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          animation: 'gradient 3s linear infinite',
          '@keyframes gradient': {
            '0%': {
              backgroundPosition: '0% center',
            },
            '100%': {
              backgroundPosition: '-300% center',
            },
          },
        }}
      >
        Google検索しています
      </Typography>
    </Box>
  );
};

export default SearchLoadingText;